import { useContext } from 'react';
import { CommandCenterStateProviderContext } from '../context';

export const useScenarioDeploymentDetails = () => {
  const context = useContext(CommandCenterStateProviderContext);
  if (!context) {
    throw new Error('useScenarioDeploymentDetails must be used within a CommandCenterStateProvider');
  }

  const { scenarioDeploymentDetails, setScenarioDeploymentDetails } = context;

  return {
    scenarioDeploymentDetails,
    setScenarioDeploymentDetails,
  };
};

export default useScenarioDeploymentDetails;
